import { createMetaDef } from '@exodus/asset'

const name = 'ethereumarbnova'
const displayName = 'Ethereum'
const ticker = 'ETHARBN'
const displayTicker = 'ETH'
const displayNetworkTicker = 'ARBN'
const displayNetworkName = 'Arbitrum Nova'
const primaryColor = '#8C93AF'
const gradientColors = ['#FF9900', '#FF9900']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = gradientColors
const chainId = 42_170

const gasLimit = 21e3 // enough to send ETH to a normal address
const contractGasLimit = 1e6 // used when estimateGas fails

const units = {
  wei: 0,
  Kwei: 3,
  Mwei: 6,
  Gwei: 9,
  szabo: 12,
  finney: 15,
  ETHARBN: 18,
}

const assetType = 'ETHEREUM_LIKE'
const tokenAssetType = 'ETHEREUM_ARBNOVA_ERC20'
const blockExplorer = {
  addressUrl: (address) => `https://nova.arbiscan.io/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://nova.arbiscan.io/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Arbitrum Nova is a layer 2 network designed for ultra-low transaction costs with high security.',
  website: 'https://nova.arbitrum.io/',
  reddit: 'https://www.reddit.com/r/Arbitrum/',
  twitter: 'https://twitter.com/arbitrum',
}

const assetParams = {
  assetType,
  blockExplorer,
  chainBadgeColors,
  chainId,
  contractGasLimit,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gasLimit,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  ticker,
  tokenAssetType,
  units,
}

export const { asset, tokens, assetsList } = createMetaDef({
  assetParams,
})

export default assetsList
